import { AutoProduct } from 'src/enums/AutoProduct'

export const enterJourneyEventName = {
  [AutoProduct.Car]: {
    sem: 'tap_btn_get_quote',
    seo: 'tap_btn_CTA_widget',
  },
  [AutoProduct.Bike]: {
    sem: 'tap_btn_get_quote',
    seo: 'tap_btn_CTA_widget',
  },
}

export const enterJourneyEkind = {
  [AutoProduct.Car]: {
    sem: 'registration_number_cta_clicked',
    seo: 'new_car_widget_clicked',
  },
  [AutoProduct.Bike]: {
    sem: 'bike_reg_no_entered',
    seo: 'insure_now_cta_clicked',
  },
}

export const newFlowJourneyEventName = {
  [AutoProduct.Car]: {
    sem: 'tap_btn_newcar_get_quote',
    seo: 'tap_btn_CTA_widget',
  },
  [AutoProduct.Bike]: {
    sem: 'tap_btn_newbike_get_quote',
    seo: 'tap_btn_CTA_widget',
  },
}

export const autoRegNoRegex = {
  [AutoProduct.Car]:
    '^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TG|TN|TS|TR|UA|UK|UP|WB)( *)( *|-)( *)([0-9]{1,2})( *)( *|-)( *)((([a-zA-Z]{1,3})( *)( *|-)( *)([0-9]{1,4}))|([0-9]{4}))$',
  [AutoProduct.Bike]:
    '^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TG|TN|TS|TR|UA|UK|UP|WB)( *)( *|-)( *)([0-9]{1,2})( *)( *|-)( *)((([a-zA-Z]{1,3})( *)( *|-)( *)([0-9]{1,4}))|([0-9]{4}))$',
}

export const autoBhRegNoRegex = {
  [AutoProduct.Car]:
    '^[2-3][0-9][B][H](([1-9]\\d\\d\\d)|(\\d[1-9]\\d\\d)|(\\d\\d\\[1-9]\\d)|(\\d\\d\\d[1-9]))[A-HJ-NP-Z]{1,2}$',
  [AutoProduct.Bike]:
    '^[2-3][0-9][B][H](([1-9]\\d\\d\\d)|(\\d[1-9]\\d\\d)|(\\d\\d\\[1-9]\\d)|(\\d\\d\\d[1-9]))[A-HJ-NP-Z]{1,2}$',
}

export const autoProposalRedirectUrl = {
  [AutoProduct.Car]: appendUrl => `/car-journey/nsr${appendUrl}&lpSource=/n`,
  [AutoProduct.Bike]: appendUrl => `/bike-journey/nsr${appendUrl}`,
}

export const newFlowJourneyEkind = {
  [AutoProduct.Car]: {
    sem: 'brand_new_car_cta_clicked',
    seo: 'new_car_widget_clicked',
  },
  [AutoProduct.Bike]: {
    sem: 'bike_brand_new_bike_clicked',
    seo: 'new_bike_widget_clicked',
  },
}

export const autoWidgetJourney = {
  [AutoProduct.Car]: {
    sem: 'buy fresh car',
    seo: 'Car Insurance',
  },
  [AutoProduct.Bike]: {
    sem: 'buy fresh bike',
    seo: 'Two Wheeler Insurance',
  },
}

export const newFlowJourney = {
  [AutoProduct.Car]: {
    sem: 'buy new car',
    seo: 'Car Insurance',
  },
  [AutoProduct.Bike]: {
    sem: 'buy new bike',
    seo: 'Two Wheeler Insurance',
  },
}
